import { useCallback } from 'react';
import { linkInvoiceNoToIndentNo } from '../services/productionService';

const useInvoiceNoCRUD = (callMessage) => {
    const processInvoice = useCallback(async (requestBody) => {
        try {
            
            // Await the API response
            const data = await linkInvoiceNoToIndentNo(requestBody);
            if (data === 'Invoice number linked with this indent no.') {
                callMessage('info', data, 'info');
            } else {
                callMessage('error', data, 'Error');
            }
        } catch (error) {
            callMessage('error', error.message || 'An unexpected error occurred', 'Error');
        }
    }, [callMessage]);

    return { processInvoice };
};

export default useInvoiceNoCRUD;

